'use client';

import { configureSync, getConsoleSink } from '@logtape/logtape';

import { getDatadogClientSink } from './logger/sinks/datadog.client';

configureSync({
  sinks: {
    console: getConsoleSink(),
    datadog: getDatadogClientSink(),
  },
  loggers: [
    {
      category: 'frontend',
      lowestLevel: 'info',
      sinks: ['console', 'datadog'],
    },
  ],
});
